module.exports = __webpack_public_path__ + "img/criterionimg4.9676fa5f.png";